import { LoadingButton } from "@mui/lab";
import { Button, Dialog, DialogActions, DialogContent, FormControl, InputLabel, MenuItem } from "@mui/material";
import PSelect from "components/PSelect";
import { CollectUserRole, CollectUserView } from "generated/graphql";
import useAppDispatchWithSnackbar from "helpers/hooks/useAppDispatchWithSnackbar";
import { useState } from "react";
import { updateCollectUserRole } from "redux/slices/client";
import { P } from "theme/typography";

interface Props {
  open: boolean;
  onClose: () => void;
  user: CollectUserView;
}

const CollectUserRoleSelector = ({ open, onClose, user }: Props) => {
  const [loading, setLoading] = useState(false);
  const snackpatch = useAppDispatchWithSnackbar();
  const [role, setRole] = useState<CollectUserRole>(user.role);

  const handleSave = () => {
    setLoading(true);
    snackpatch(
      updateCollectUserRole({
        collectUserId: user.id,
        role,
      }),
      {
        successMessage: "Role updated",
        errorMessage: "Unable to update role",
      }
    )
      .then(onClose)
      .finally(() => setLoading(false));
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogContent>
        <P variant="lgBold">User Role</P>
        <FormControl sx={{ mt: 2 }} required fullWidth>
          <InputLabel>Role</InputLabel>
          <PSelect
            fullWidth
            label="Role"
            required
            name="role"
            value={role}
            onChange={(evt) => setRole(evt.target.value as CollectUserRole)}>
            <MenuItem value={CollectUserRole.Viewer}>Viewer</MenuItem>
            <MenuItem value={CollectUserRole.Contributor}>Contributor</MenuItem>
            <MenuItem value={CollectUserRole.Admin}>Admin</MenuItem>
          </PSelect>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <LoadingButton onClick={handleSave} loading={loading} variant="contained">
          Save
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default CollectUserRoleSelector;
